import React, { useEffect } from "react";
import "./assets/scss/themes.scss";
import RouteIndex from "routes";

import fakeBackend from "./helpers/auth-type/fakeBackend";
import { useAppDispatch, useAppSelector } from "slices/hook";
import { getLayoutState, setBrandingDataAction } from "slices/layouts/reducer";
import { AppDispatch } from "slices/store";

import { getAuthState } from "slices/auth/login/reducer";

import { setupAxiosIntercepters } from "api/axios/axios-interceptors";

// Activating fake backend
fakeBackend();

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  /*  async function fetchBrandingData() {
    try {
      const response = await fetch("./assets/settings/branding.json"); // Replace with actual path
      const brandingData = await response.json();
      // Use brandingData as needed
      console.log(brandingData);
      dispatch(setBrandingDataAction(brandingData));
    } catch (error) {
      console.error("Error fetching branding data:", error);
    }
  } */

  const dispatch: AppDispatch = useAppDispatch();
  const { branding } = useAppSelector(getLayoutState);

  const userStore = useAppSelector(getAuthState);
  setupAxiosIntercepters(userStore);

  useEffect(() => {
    //  fetchBrandingData();
    /*  if ((branding?.siteName ?? "") == "" || branding?.version != brandingData?.version) {
     
    } */
  }, []);
  return <RouteIndex />;
}

export default App;
